import { Calendar, MapPin, Navigation, Phone, Users } from "lucide-react";
import { WhatsAppLogo } from "../WhatsAppLogo";

const STATUS = {
  new: { label: "New", cls: "bg-gold text-black" },
  confirmed: { label: "Confirmed", cls: "bg-sky-500/20 text-sky-300" },
  done: { label: "Done", cls: "bg-wa/20 text-wa" },
  cancelled: { label: "Cancelled", cls: "bg-red-500/20 text-red-300" },
};

const fmt = (iso) =>
  new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function BookingCard({ booking: b, onStatus }) {
  const digits = b.phone.replace(/[^0-9+]/g, "");
  const waDigits = digits.replace(/^\+/, "").replace(/^0/, "49");
  const when = [b.date, b.time].filter(Boolean).join(" · ") || "As soon as possible";

  return (
    <div data-testid={`booking-card-${b.id}`} className="rounded-2xl border border-white/5 bg-coal p-6 transition-colors hover:border-gold/25">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="font-serif text-2xl">{b.name}</div>
          <div className="mt-1 text-xs text-white/45">Received {fmt(b.created_at)}</div>
        </div>
        <span data-testid={`booking-status-${b.id}`} className={`rounded-full px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider ${STATUS[b.status].cls}`}>
          {STATUS[b.status].label}
        </span>
      </div>

      <div className="mt-5 grid gap-3 text-sm sm:grid-cols-2">
        <Row icon={MapPin} label="Pickup" value={b.pickup} />
        <Row icon={Navigation} label="Destination" value={b.destination} />
        <Row icon={Calendar} label="When" value={when} />
        <Row icon={Users} label="Passengers" value={b.passengers} />
      </div>
      {b.notes && <p className="mt-4 rounded-xl bg-white/5 px-4 py-3 text-sm text-white/75">{b.notes}</p>}

      <div className="mt-5 flex flex-wrap items-center gap-2">
        <a data-testid={`booking-call-${b.id}`} href={`tel:${digits}`} className="inline-flex items-center gap-2 rounded-full bg-callope px-4 py-2.5 text-sm font-extrabold text-white">
          <Phone className="h-4 w-4" /> {b.phone}
        </a>
        <a data-testid={`booking-wa-${b.id}`} href={`https://wa.me/${waDigits}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-wa px-4 py-2.5 text-sm font-extrabold text-white">
          <WhatsAppLogo className="h-4 w-4" /> WhatsApp
        </a>
        <div className="ml-auto flex flex-wrap gap-1.5">
          {Object.keys(STATUS).map((s) => (
            <button
              key={s}
              data-testid={`booking-set-${s}-${b.id}`}
              onClick={() => onStatus(b.id, s)}
              disabled={b.status === s}
              className="rounded-full border border-white/10 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white/70 transition-colors hover:border-gold/40 hover:text-gold disabled:border-gold/40 disabled:text-gold"
            >
              {STATUS[s].label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-2.5">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/45">{label}</div>
        <div className="font-semibold text-white">{value}</div>
      </div>
    </div>
  );
}
